import {generatePath, useNavigate, useParams, useSearchParams} from 'react-router';
import {routes} from '~/routing/routes';

/** Opens another tab of this category's profile (e.g. 'overview'), keeping the selected category. */
export function useOpenProfileTab(): (tab: string) => void {
    const navigate = useNavigate();
    const {id = ''} = useParams<{id: string}>();
    const [params] = useSearchParams();
    return tab => navigate({pathname: generatePath(routes.category_profile, {id, tab}), search: params.toString()});
}
